import { useCreateTalentInfluencerMutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper } from '@anytag/shared-hooks';
import {
  TalentInfluencerForm,
  TalentInfluencerFormValues,
  getCreateUpdateTalentInfluencerInput
} from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';

export const AddInfluencerForTalentAgency = () => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { callCreateTalentInfluencer } = useCreateTalentInfluencerMutation();

  const handleSubmit: FormAction<TalentInfluencerFormValues>['onSubmit'] = async (values) => {
    try {
      const input = getCreateUpdateTalentInfluencerInput(values);
      await callCreateTalentInfluencer({ variables: { input } });

      enqueueSnackbar(t('succeededInCreating', { name: values.name }), { variant: 'success' });
      navigate({ to: '/influencers' });
    } catch (error) {
      enqueueSnackbar(t('failedToCreate', { name: values.name }), { variant: 'error' });
      enqueueSnackbar(t(error.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return <TalentInfluencerForm onSubmit={handleSubmit} />;
};
